export default {
  namespaced: true,
  intelexvision: {
    title: "intelexvision",
    host: "host",
    description: "descripcion",
    tenant: "tenant",
    servers: "servidores",
 }
}
